// extracted by mini-css-extract-plugin
export default {"container":"_I-z","disabled":"aJ-z","bgBlack":"bJ-z","content":"cJ-z","countdown":"dJ-z","topCaption":"eJ-z","topHeading":"fJ-z","heading":"gJ-z","copy":"hJ-z"};